import { useGetETSTicketCommentsQuery } from 'gcs-common/clients/api/entities/tickets/tickets-api';
import { useGetETSTicketNotificationSelector } from 'gcs-common/clients/api/entities/tickets/tickets-api-selectors';
import LoadingIndicator from 'gcs-common/components/LoadingIndicator/LoadingIndicator';
import orderBy from 'lodash-es/orderBy';
import { useMemo } from 'react';
import styles from './styles.module.scss';
import TicketComment from './TicketComment/TicketComment';

interface TicketCommentsListProps {
  ticketId: string;
}

const TicketCommentsList = (props: TicketCommentsListProps) => {
  const { ticketId } = props;
  const { data: commentsData, isFetching: commentsLoading } = useGetETSTicketCommentsQuery({
    path: {
      ticket_id: ticketId,
    },
  });
  const comments = useMemo(() => (commentsData ? commentsData.comments : []), [commentsData]);
  const ticketNotification = useGetETSTicketNotificationSelector(ticketId);

  const commentsSorted = useMemo(() => orderBy(comments, 'createdAt', 'desc'), [comments]);

  return (
    <div className={styles.commentsList}>
      {commentsLoading && !comments && <LoadingIndicator />}
      {comments &&
        commentsSorted.map((comment) => (
          <TicketComment
            key={comment.id}
            ticketId={ticketId}
            comment={comment}
            ticketNotification={ticketNotification}
          />
        ))}
    </div>
  );
};

export default TicketCommentsList;
